/* eslint i18next/no-literal-string: 0 */
import i18n from "i18next";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(HttpApi)
  //.use(LanguageDetector) TODO: MESH-727 re-enable language detection when multiple languages are supported
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    backend: {
      loadPath: `${import.meta.env.VITE_I18NEXT_BASE_URL}/{{lng}}/{{ns}}.json`
    },
    detection: {
      order: ["querystring", "cookie", "navigator"],
      caches: ["cookie"]
    },
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    fallbackLng: "en-AU",
    ns: ["common", "cases", "users", "template", "subscription"],
    defaultNS: "common",
    fallbackNS: "common",
    lowerCaseLng: true,
    nonExplicitSupportedLngs: true,
    ...(import.meta.env.VITE_ENABLE_I18NEXT_DEBUG && { debug: true })
  });

export { i18n };

// MUST INCLUDE ALL SUPPORTED LOCALES
export const I18N_LOCALES = ["en-AU"];
